import { useAuth } from 'oidc-react';
import React, { useEffect, useState } from 'react'
import { IdentityContext } from './IdentityContext';
import { useHttp } from '../../common/http/httpService';
import useTelemetry from '../telemetry/telemetryService';
import useErrorReporting from '../errorReporting/errorReportingService';

const IdentityProvider = ({ children }) => {
  const auth = useAuth();
  const http = useHttp();
  const [user, setUser] = useState({});
  const [fetchedUser, setFetchedUser] = useState(false);
  const { clearContext:clearTelemetryContext, setContext:setTelemetryContext } = useTelemetry();
  const { clearContext:clearErrorReportingContext, setContext:setErrorReportingContext } = useErrorReporting();


  useEffect(() => {
    const fetchUser = async() => {
      const loggedInUser = await http.get('/user');
      setFetchedUser(true);
      setUser(loggedInUser);
    };

    if (auth.isLoading) {
      setFetchedUser(false);
    }
    else if (auth.userData && !fetchedUser) {
      fetchUser();
    }
  }, [http, fetchedUser, auth.isLoading, auth.userData])

  useEffect(() => {
    if (auth.isLoading) {
      clearErrorReportingContext();
    }
    else if (fetchedUser && user.id) {
      setErrorReportingContext(user);
    }
  }, [fetchedUser, user, auth.isLoading, clearErrorReportingContext, setErrorReportingContext])

  useEffect(() => {
    if (auth.isLoading) {
      clearTelemetryContext();
    }
    else if (fetchedUser && user.id) {
      setTelemetryContext(user);
    }
  }, [fetchedUser, user, auth.isLoading, clearTelemetryContext, setTelemetryContext])

  if (auth.isLoading) {
    return null;
  }

  return (
    <IdentityContext.Provider value={{
      ...user,
    }}>
      {children}
    </IdentityContext.Provider>
  )
};

export default IdentityProvider;
